import { localize } from "../../i18n";
import { STRING } from "../../i18n/base";

export const validateBodyShapeHipStep = (profile, config) => {
  // BodyShapeHip;

  if (validateBodyShapeHip(profile.hipOffset)) {
    return false;
  }
  return true;
};

export const validateBodyShapeHip = (value) => {
  if (value === "") {
    return localize(STRING.REQUIRED, {
      fieldName: localize(STRING.HIP),
    });
  }
  return false;
};
